import { Channel } from '@whitbread-eos/api';
import { useCustomLocale, useHotelBrands } from '@whitbread-eos/utils';
import { useRouter } from 'next/router';
import HeaderVariantStep from './HeaderVariantStep.component';
import { jsx as _jsx } from "react/jsx-runtime";
export default function HeaderVariantStepContainer(_ref) {
  var headerInfoData = _ref.headerInfoData,
    _ref$bb = _ref.bb,
    bb = _ref$bb === void 0 ? false : _ref$bb,
    queryClient = _ref.queryClient;
  var _ref2 = useRouter() || {
      query: {},
      route: ''
    },
    query = _ref2.query;
  var _useCustomLocale = useCustomLocale(),
    language = _useCustomLocale.language,
    country = _useCustomLocale.country;
  var basketReference = query !== null && query !== void 0 && query.reservationId ? String(query.reservationId) : '';
  var _useHotelBrands = useHotelBrands({
      basketReference,
      channel: bb ? Channel.Bb : Channel.Pi,
      queryClient
    }),
    brand = _useHotelBrands.brand,
    stepProgress = _useHotelBrands.stepProgress;
  return _jsx(HeaderVariantStep, {
    currentLang: language,
    currentCountry: country,
    headerInfoData: headerInfoData,
    propsStepProgress: stepProgress,
    hotelBrand: brand,
    bb: bb
  });
}